import * as React from "react";
import { SyncType } from "./SyncTypes";

type SyncContextProps = {
  type?: SyncType;
};

export const SyncContext = React.createContext<SyncContextProps>({});
